import React, { Component } from "react";
import { Field } from "formik";

class FormikRadioButton extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let props = this.props;
    return (
      <Field name={props.name}>
        {({ field, form }) => (
          <label>
            <input
              type="radio"
              {...props}
              checked={field.value === props.value}
              onChange={() => { form.setFieldValue(field.name, props.value) }}
            />
            {props.label ? props.label : props.value}
          </label>
        )}
      </Field>
    );
  }
}

export default FormikRadioButton;
